module.exports = __webpack_public_path__ + "img/mutasi.f7358f7d.png";